import { type ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  hint?: string;
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({
  icon,
  title,
  hint,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <div
      className={
        compact
          ? 'flex flex-col items-center justify-center text-center py-8 px-4 text-slate-500'
          : 'flex flex-col items-center justify-center text-center py-16 px-6 text-slate-500'
      }
    >
      <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center mb-3 text-slate-400">
        {icon ?? <Inbox size={18} />}
      </div>
      <p className="text-sm font-semibold text-slate-700">{title}</p>
      {hint && <p className="text-xs text-slate-500 mt-1 max-w-md">{hint}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
